import { api } from "./api";

// Label format presets — dimensions en mm (height: null = AUTO calculé selon le contenu)
export const LABEL_FORMATS = {
  C3500_51x160: { id: "C3500_51x160", label: "51 × 160 mm (C3500 — défaut)", width: 51, height: 160, printer: "Epson C3500" },
  C3500_51x180: { id: "C3500_51x180", label: "51 × 180 mm (C3500)", width: 51, height: 180, printer: "Epson C3500" },
  C3500_51x190: { id: "C3500_51x190", label: "51 × 190 mm (C3500)", width: 51, height: 190, printer: "Epson C3500" },
  C3500_51x_AUTO: { id: "C3500_51x_AUTO", label: "51 × auto (s'adapte au contenu)", width: 51, height: null, printer: "Epson C3500" },
  C3500_102x51: { id: "C3500_102x51", label: "102 × 51 mm (C3500)", width: 102, height: 51, printer: "Epson C3500" },
  C3500_102x76: { id: "C3500_102x76", label: "102 × 76 mm (C3500)", width: 102, height: 76, printer: "Epson C3500" },
  C3500_102x152: { id: "C3500_102x152", label: "102 × 152 mm (C3500)", width: 102, height: 152, printer: "Epson C3500" },
  C3500_76x51: { id: "C3500_76x51", label: "76 × 51 mm (C3500)", width: 76, height: 51, printer: "Epson C3500" },
  A4: { id: "A4", label: "A4 (feuille standard)", width: 210, height: 297, printer: "Imprimante bureau" },
};

export const DEFAULT_FORMAT_ID = "C3500_51x160";

const DEFAULTS = {
  printer_name: "Epson ColorWorks C3500",
  printer_ip: "",
  default_format: DEFAULT_FORMAT_ID,
  company_name: "AgroManage",
  company_address: "",
  company_logo: "",
};

// Synchronous read (from localStorage cache)
export function getSettings() {
  try {
    const s = JSON.parse(localStorage.getItem("agromanage_settings") || "{}");
    return { ...DEFAULTS, ...s };
  } catch {
    return { ...DEFAULTS };
  }
}

// Async fetch from backend → updates cache
// Phase 101gd (Feb 2026) — `withLogo=true` récupère aussi le logo base64
// (~430KB). Utilisé uniquement par Settings + Labels. Défaut : slim.
export async function loadSettings({ withLogo = false } = {}) {
  const { data } = await api.get(withLogo ? "/settings?include_logo=true" : "/settings");
  const merged = { ...DEFAULTS, ...data };
  localStorage.setItem("agromanage_settings", JSON.stringify(merged));
  return merged;
}

// Save to backend + cache locally
export async function saveSettings(s) {
  const { id, ...payload } = s;
  const { data } = await api.put("/settings", payload);
  const merged = { ...DEFAULTS, ...data };
  localStorage.setItem("agromanage_settings", JSON.stringify(merged));
  return merged;
}

// 1mm = 2.83465 pt
export const MM_TO_PT = 2.83465;
